import { CustomField, CustomFieldEntitySubType } from '../../../../types/custom_field';
import { PdfTemplateEntityType } from '../../../../types/pdf_template';
import { toMap } from '../../../../util/map.util';
import { PdfTableType } from '../PdfComponent';
import { PdfBinDataResolver } from './entities/PdfBin';
import { PdfContainerDataResolver } from './entities/PdfContainer';
import { PdfFileDataResolver } from './entities/PdfFileDataResolver';
import { PdfLotDataResolver } from './entities/PdfLot';
import { PdfOrderDataResolver } from './entities/PdfOrder';
import { PdfProductMasterDataDataResolver } from './entities/PdfProductMasterData';
import { PdfProductTransactionDataResolver } from './entities/PdfProductTransaction';
import { PdfStockLocationDataResolver } from './entities/PdfStockLocation';

export enum PdfFieldEntity {
  pdf = 'pdf',
  stockLocation = 'stockLocation',
  order = 'order',
  bin = 'bin',
  productMasterData = 'productMasterData',
  lot = 'lot',
  container = 'container',
  productTransaction = 'productTransaction',
}

export function pdfTemplateEntityTypeToFieldEntity(entityType: PdfTemplateEntityType): PdfFieldEntity {
  switch (entityType) {
    case PdfTemplateEntityType.order:
      return PdfFieldEntity.order;
  }
}

export function pdfTemplateTableTypeToFieldEntity(tableType: PdfTableType): PdfFieldEntity {
  switch (tableType) {
    case PdfTableType.productTransaction:
      return PdfFieldEntity.productTransaction;
  }
}

export enum PdfSubkey {
  source = 'source',
  destination = 'destination',
}

export type PdfDataKey<P> = {
  entityType: PdfFieldEntity;
  subkey?: PdfSubkey;
} & ({ property: P } | { customFieldId: string });

// export function getPdfDataKeyHash<P>(key: PdfDataKey<P>): string {
//   if ('customFieldId' in key) {
//     return `${key.entityType}|${key.customFieldId}|${key.subkey || ''}`;
//   }

//   return `${key.entityType}|${key.property}|${key.subkey || ''}`;
// }

export function getOrderDataKeys(customFields: Map<string, CustomField>, image: boolean = false): PdfDataKey<any>[] {
  const subkeys = [PdfSubkey.source, PdfSubkey.destination];
  return [
    ...new PdfFileDataResolver().getDataKeys(customFields, undefined, image),
    ...new PdfOrderDataResolver(new Map()).getDataKeys(customFields, undefined, image),
    ...new PdfStockLocationDataResolver().getDataKeysWithSubkeys(customFields, subkeys, image),
  ];
}

function customFieldEntitySubTypeToSubkeys(customFieldEntitySubType: CustomFieldEntitySubType) {
  switch (customFieldEntitySubType) {
    case CustomFieldEntitySubType.inbound:
    case CustomFieldEntitySubType.replenish:
      return [PdfSubkey.destination];
    case CustomFieldEntitySubType.outbound:
    case CustomFieldEntitySubType.disposal:
      return [PdfSubkey.source];
    case CustomFieldEntitySubType.move:
      return [PdfSubkey.source, PdfSubkey.destination];
  }
}

export function getProductTransactionDataKeys(
  customFields: Map<string, CustomField>,
  subkeys?: PdfSubkey[],
): PdfDataKey<any>[] {
  subkeys ||= [PdfSubkey.source, PdfSubkey.destination];
  customFields = toMap(
    [...customFields.values()].filter(
      cf => !cf.entitySubtype || subkeys?.some(s => customFieldEntitySubTypeToSubkeys(cf.entitySubtype!).includes(s)),
    ),
    'id',
  );
  return [
    ...new PdfProductTransactionDataResolver(new Map()).getDataKeys(customFields),
    ...new PdfProductMasterDataDataResolver().getDataKeys(customFields),
    ...new PdfBinDataResolver().getDataKeysWithSubkeys(customFields, subkeys),
    ...new PdfContainerDataResolver().getDataKeysWithSubkeys(customFields, subkeys),
    ...new PdfLotDataResolver().getDataKeys(customFields),
  ];
}
